import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgcFloatButtonModule } from 'ngc-float-button';
import { FormsModule } from '@angular/forms';


import { AngularSvgIconModule } from 'angular-svg-icon';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { DynamicFormComponent }         from './dynamic-form/dynamic-form.component';
import { DynamicFormQuestionComponent } from './dynamic-form-question/dynamic-form-question.component';

import { QuestionJsonService } from './services/question-json/question-json.service';
import { QuestionService } from './services/question/question.service';
import { FormValuesService } from './services/form-values/form-values.service';
import { ChartService } from './chart.service';
import { ApiService } from './services/api/api.service';
import { CustomerEditService } from './services/customer-edit/customer-edit.service';
import { ModalService } from './services/modal/modal.service';

import { GenericFormPageComponent } from './generic-form-page/generic-form-page.component';
import { AuswertungComponent } from './auswertung/auswertung.component';
import { UebersichtComponent } from './auswertung/uebersicht/uebersicht.component';
import { KrankheitComponent } from './auswertung/krankheit/krankheit.component';
import { EmBuComponent } from './auswertung/em-bu/em-bu.component';
import { UnfallComponent } from './auswertung/unfall/unfall.component';
import { AlterComponent } from './auswertung/alter/alter.component';
import { PflegeComponent } from './auswertung/pflege/pflege.component';
import { TestComponent } from './test/test.component';
import { PreventionModalComponent } from './prevention-modal/prevention-modal.component';

import { Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { AdvisorModalComponent } from './advisor-modal/advisor-modal.component';

import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatterDE } from './services/datepicker-format/datepicker-format.service';
import { DynamicFormBuilderComponent } from './dynamic-form-builder/dynamic-form-builder.component'
import { CustomerOverviewComponent } from './customer-overview/customer-overview.component';
import { CustomerEditComponent } from './customer-overview/customer-edit/customer-edit.component';
import { CommonModule } from '@angular/common';

import { D3Service, D3_DIRECTIVES } from './d3';
import { GraphComponent } from './visuals/graph/graph.component';
import { SHARED_VISUALS } from './visuals/shared';
import { ModalContentComponent } from './modal-content/modal-content.component';

import { RoundPipe } from './pipes/round.pipe';
import { CustomerSearchPipe } from './pipes/customer-search.pipe';
import { SafeHtml } from './pipes/safe-html.pipe';
import { customCurrency } from './pipes/custom-currency.pipe';

import { GravatarModule } from  'ngx-gravatar';
import { DiagramComponent } from './diagram/diagram.component';

@NgModule({
  declarations: [
    AppComponent,
    DynamicFormComponent,
    DynamicFormQuestionComponent,
    GenericFormPageComponent,
    AuswertungComponent,
    UebersichtComponent,
    KrankheitComponent,
    EmBuComponent,
    UnfallComponent,
    AlterComponent,
    PflegeComponent,
    TestComponent,
    SafeHtml,
    AdvisorModalComponent,
    RoundPipe,
    DynamicFormBuilderComponent,
    CustomerOverviewComponent,
    CustomerSearchPipe,
    customCurrency,
    CustomerEditComponent,
    GraphComponent,
    ...SHARED_VISUALS,
    ...D3_DIRECTIVES,
    PreventionModalComponent,
    ModalContentComponent,
    DiagramComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule.forRoot(),
    NgcFloatButtonModule,
    FormsModule,
    AngularSvgIconModule,
    GravatarModule
  ],
  entryComponents: [
    AdvisorModalComponent,
    ModalContentComponent,
  ],
  providers: [
    QuestionJsonService,
    QuestionService,
    FormValuesService,
    ApiService,
    ChartService,
    CustomerEditService,
    D3Service,
    ModalService,
    {provide: NgbDateParserFormatter, useClass: NgbDateParserFormatterDE } ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts